import { createReducer, on } from "@ngrx/store";
import { UiState } from '../state';

import * as fromActions from '../actions';

const initState: UiState = {
  showSideFilters: false,
  loadingMaterialesSimilares: false,
  loadingDetail: false,
  loadingMaestros: false,
  loadingStock: false,

}

export const uiReducer = createReducer(
  initState,
  on(fromActions.togglShowSideFilter, state => {
    return {
      ...state,
      showSideFilters : !state.showSideFilters
    }
  }),
  // details
  on(fromActions.loadDetailsRequest, state => {
    return {
      ...state,
      loadingDetail : true
    }
  }),
  on(fromActions.loadDetails, state => {
    return {
      ...state,
      loadingDetail: false
    }
  }),
  // materiales similares
  on(fromActions.loadMaterialesSimilaresRequest, state => {
    return {
      ...state,
      loadingMaterialesSimilares: true
    }
  }),
  on(fromActions.loadMaterialesSimilares, state => {
    return {
      ...state,
      loadingMaterialesSimilares: false
    }
  }),
  // maestros
  on(fromActions.loadMaestrosMaterialRequest, state => {
    return {
      ...state,
      loadingMaestros: true
    }
  }),
  on(fromActions.loadMaestrosMaterial, state => {
    return {
      ...state,
      loadingMaestros: false
    }
  }),
  // stock
  on(fromActions.loadStockRequest, state => {
    return {
      ...state,
      loadingStock: true
    }
  }),
  on(fromActions.loadStock, state => {
    return {
      ...state,
      loadingStock: false
    }
  })
)
